import liff from '@line/liff';

export async function initLiff(): Promise<{ idToken: string; userId: string; displayName: string | null }> {
  const liffId = import.meta.env.VITE_LIFF_ID;
  if (!liffId) throw new Error('VITE_LIFF_ID is not set');

  await liff.init({ liffId });

  if (!liff.isLoggedIn()) {
    liff.login();
    // login() で再リダイレクトされるためここに戻ることはない
    return await new Promise(() => {});
  }

  const idToken = liff.getIDToken();
  if (!idToken) throw new Error('Failed to get idToken');

  const profile = await liff.getProfile();
  return { idToken, userId: profile.userId, displayName: profile.displayName };
}

export function liffClose() {
  if (liff.isInClient()) liff.closeWindow();
}

export function liffOpenExternal(url: string) {
  if (liff.isInClient()) {
    liff.openWindow({ url, external: true });
  } else {
    window.open(url, '_blank');
  }
}
